import { ChangeDetectionStrategy, Component, input } from '@angular/core';


@Component({
  selector: 'lib-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  logoSrc = input<string>('');
}
